<script>
import Head from '@/components/Head';
import Button from '@/components/Button';
import Input from '@/components/Input';
import Select from '@/components/Select';
import Loader from '@/components/Loader';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
    data() {
        return {
            loader: false,
            activeTab: 'templates', // templates, queue, send
            templates: [],
            queueStatus: null,
            recentQueue: [],
            
            // Template form
            templateForm: {
                id: null,
                name: '',
                subject: '',
                body: '',
                type: 'geral',
                is_active: true,
            },
            editingTemplate: false,
            
            // Send form
            sendForm: {
                template_id: '',
                recipient_type: 'todos',
            },
            
            templateTypes: [
                { name: 'Geral', value: 'geral' },
                { name: 'Inadimplentes', value: 'inadimplentes' },
                { name: 'Adimplentes', value: 'adimplentes' },
                { name: 'Todos os Associados', value: 'todos' },
                { name: 'Ativos', value: 'ativos' },
                { name: 'Inativos', value: 'inativos' },
            ],
            
            recipientTypes: [
                { name: 'Todos os Associados', value: 'todos' },
                { name: 'Adimplentes', value: 'adimplentes' },
                { name: 'Inadimplentes', value: 'inadimplentes' },
                { name: 'Ativos', value: 'ativos' },
                { name: 'Inativos', value: 'inativos' },
                { name: 'Excluídos', value: 'Excluídos' },
            ],
        }
    },
    props: {
        userData: {
            type: Object
        }
    },
    created() {
        if (this.userData.role === 'associate') {
            this.$router.push('/inicio');
        }
        
        this.loadTemplates();
        this.loadQueueStatus();
        
        // Atualizar status da fila a cada 30 segundos
        setInterval(() => {
            if (this.activeTab === 'queue') {
                this.loadQueueStatus();
            }
        }, 30000);
    },
    methods: {
        notify(text, type) {
            toast(text, {
                "type": type == 'info' ? 'info' : type == 'warning' ? 'warning' : type == 'error' ? 'error' : type == 'success' ? 'success' : 'default',
            });
        },

        loadTemplates() {
            this.loader = true;
            this.$axios.get('/notifications/templates')
            .then(res => {
                this.templates = res.data.data;
                this.loader = false;
            })
            .catch(err => {
                this.notify(err.response?.data?.message || 'Erro ao carregar templates!', 'error');
                this.loader = false;
            });
        },

        loadQueueStatus() {
            this.$axios.get('/notifications/queue/status')
            .then(res => {
                this.queueStatus = res.data.data.summary;
                this.recentQueue = res.data.data.recent_queue;
            })
            .catch(err => {
                console.error('Erro ao carregar status da fila:', err);
            });
        },

        saveTemplate() {
            if (!this.templateForm.name || !this.templateForm.subject || !this.templateForm.body) {
                return this.notify('Preencha todos os campos obrigatórios!', 'warning');
            }

            this.loader = true;

            const request = this.editingTemplate
                ? this.$axios.put(`/notifications/templates/${this.templateForm.id}`, this.templateForm)
                : this.$axios.post('/notifications/templates', this.templateForm);

            request.then(res => {
                this.notify(res.data.message, 'success');
                this.loadTemplates();
                this.resetTemplateForm();
                this.loader = false;
            })
            .catch(err => {
                this.notify(err.response?.data?.message || 'Erro ao salvar template!', 'error');
                this.loader = false;
            });
        },

        editTemplate(template) {
            this.templateForm = { ...template };
            this.editingTemplate = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },

        deleteTemplate(id) {
            if (!confirm('Tem certeza que deseja deletar este template?')) return;

            this.loader = true;
            this.$axios.delete(`/notifications/templates/${id}`)
            .then(res => {
                this.notify(res.data.message, 'success');
                this.loadTemplates();
                this.loader = false;
            })
            .catch(err => {
                this.notify(err.response?.data?.message || 'Erro ao deletar template!', 'error');
                this.loader = false;
            });
        },

        resetTemplateForm() {
            this.templateForm = {
                id: null,
                name: '',
                subject: '',
                body: '',
                type: 'geral',
                is_active: true,
            };
            this.editingTemplate = false;
        },

        queueEmails() {
            if (!this.sendForm.template_id || !this.sendForm.recipient_type) {
                return this.notify('Selecione um template e o tipo de destinatário!', 'warning');
            }

            if (!confirm('Tem certeza que deseja adicionar estes emails à fila?')) return;

            this.loader = true;
            this.$axios.post('/notifications/queue', this.sendForm)
            .then(res => {
                this.notify(res.data.message, 'success');
                this.loadQueueStatus();
                this.sendForm.template_id = '';
                this.sendForm.recipient_type = 'todos';
                this.activeTab = 'queue';
                this.loader = false;
            })
            .catch(err => {
                this.notify(err.response?.data?.message || 'Erro ao adicionar emails à fila!', 'error');
                this.loader = false;
            });
        },

        processQueue() {
            if (!confirm('Deseja processar a fila manualmente? (Normalmente isto é feito automaticamente)')) return;

            this.loader = true;
            this.$axios.post('/notifications/queue/process')
            .then(res => {
                this.notify(res.data.message, 'success');
                this.loadQueueStatus();
                this.loader = false;
            })
            .catch(err => {
                this.notify(err.response?.data?.message || 'Erro ao processar fila!', 'error');
                this.loader = false;
            });
        },

        clearQueue(status = 'sent') {
            const confirmMsg = status === 'all' 
                ? 'Deseja limpar TODOS os registros enviados e falhados da fila?'
                : 'Deseja limpar os registros ' + status + ' da fila?';

            if (!confirm(confirmMsg)) return;

            this.loader = true;
            this.$axios.delete('/notifications/queue/clear', { params: { status } })
            .then(res => {
                this.notify(res.data.message, 'success');
                this.loadQueueStatus();
                this.loader = false;
            })
            .catch(err => {
                this.notify(err.response?.data?.message || 'Erro ao limpar fila!', 'error');
                this.loader = false;
            });
        },

        insertVariable(variable) {
            this.templateForm.body += ' ' + variable + ' ';
        },

        getStatusBadgeClass(status) {
            const classes = {
                'pending': 'badge-warning',
                'processing': 'badge-info',
                'sent': 'badge-success',
                'failed': 'badge-danger',
            };
            return classes[status] || 'badge-secondary';
        },

        getStatusLabel(status) {
            const labels = {
                'pending': 'Pendente',
                'processing': 'Processando',
                'sent': 'Enviado',
                'failed': 'Falhou',
            };
            return labels[status] || status;
        },

        formatDateTime(dateString) {
            if (!dateString) return '-';
            const date = new Date(dateString);
            return date.toLocaleString('pt-BR');
        },
    },
    components: { Head, Button, Input, Select, Loader }
}
</script>

<template>
    <section class="notifications-container">
        <Loader v-if="loader" />
        
        <Head title="Avisos Automáticos" />

        <div class="header-section">
            <h2>📧 Avisos Automáticos por Email</h2>
            <p class="subtitle">Gerencie templates e envie notificações em lote para associados</p>
        </div>

        <!-- Tabs Navigation -->
        <div class="tabs-nav">
            <button 
                :class="['tab-button', { active: activeTab === 'templates' }]"
                @click="activeTab = 'templates'"
            >
                📝 Templates
            </button>
            <button 
                :class="['tab-button', { active: activeTab === 'send' }]"
                @click="activeTab = 'send'"
            >
                📤 Enviar Avisos
            </button>
            <button 
                :class="['tab-button', { active: activeTab === 'queue' }]"
                @click="activeTab = 'queue'; loadQueueStatus()"
            >
                📊 Fila de Envio
                <span v-if="queueStatus && queueStatus.pending > 0" class="badge-pending">{{ queueStatus.pending }}</span>
            </button>
        </div>

        <!-- Tab: Templates -->
        <div v-if="activeTab === 'templates'" class="tab-content">
            <div class="form-section">
                <h3>{{ editingTemplate ? 'Editar Template' : 'Novo Template' }}</h3>
                
                <div class="form-row">
                    <Input 
                        label="Nome do Template*" 
                        placeholder="Ex: Aviso de Inadimplência"
                        :value="templateForm.name" 
                        v-model="templateForm.name"
                    />
                </div>

                <div class="form-row">
                    <Input 
                        label="Assunto do Email*" 
                        placeholder="Ex: Aviso Importante - ANIPP"
                        :value="templateForm.subject" 
                        v-model="templateForm.subject"
                    />
                    <div class="form-space"></div>
                    <Select 
                        label="Tipo de Template" 
                        :options="templateTypes" 
                        :value="templateForm.type" 
                        v-model="templateForm.type"
                    />
                </div>

                <div class="form-row">
                    <div class="form-group full-width">
                        <label>Corpo do Email* (HTML suportado)</label>
                        <textarea 
                            v-model="templateForm.body" 
                            rows="10"
                            placeholder="Digite o conteúdo do email aqui..."
                            class="form-textarea"
                        ></textarea>
                    </div>
                </div>

                <div class="variables-help">
                    <p><strong>Variáveis disponíveis (clique para inserir):</strong></p>
                    <div class="variables-buttons">
                        <button @click="insertVariable('{{nome}}')" class="var-btn">{<!-- -->{nome}}</button>
                        <button @click="insertVariable('{{email}}')" class="var-btn">{<!-- -->{email}}</button>
                        <button @click="insertVariable('{{cpf}}')" class="var-btn">{<!-- -->{cpf}}</button>
                        <button @click="insertVariable('{{matricula}}')" class="var-btn">{<!-- -->{matricula}}</button>
                        <button @click="insertVariable('{{situacao_financeira}}')" class="var-btn">{<!-- -->{situacao_financeira}}</button>
                        <button @click="insertVariable('{{debitos_anteriores}}')" class="var-btn">{<!-- -->{debitos_anteriores}}</button>
                    </div>
                </div>

                <div class="form-row">
                    <label class="checkbox-label">
                        <input type="checkbox" v-model="templateForm.is_active" />
                        Template Ativo
                    </label>
                </div>

                <div class="form-actions">
                    <Button type="primary" :placeholder="editingTemplate ? 'Atualizar Template' : 'Criar Template'" @buttonPressed="saveTemplate" />
                    <Button v-if="editingTemplate" type="secondary" placeholder="Cancelar" @buttonPressed="resetTemplateForm" />
                </div>
            </div>

            <div class="templates-list">
                <h3>Templates Cadastrados ({{ templates.length }})</h3>
                
                <div v-if="templates.length === 0" class="empty-state">
                    <p>Nenhum template cadastrado ainda.</p>
                </div>

                <div v-for="template in templates" :key="template.id" class="template-card">
                    <div class="template-header">
                        <h4>{{ template.name }}</h4>
                        <div class="template-badges">
                            <span class="badge badge-type">{{ template.type }}</span>
                            <span :class="['badge', template.is_active ? 'badge-success' : 'badge-danger']">
                                {{ template.is_active ? 'Ativo' : 'Inativo' }}
                            </span>
                        </div>
                    </div>
                    <div class="template-body">
                        <p><strong>Assunto:</strong> {{ template.subject }}</p>
                        <p><strong>Criado em:</strong> {{ formatDateTime(template.created_at) }}</p>
                    </div>
                    <div class="template-actions">
                        <button @click="editTemplate(template)" class="btn-edit">✏️ Editar</button>
                        <button @click="deleteTemplate(template.id)" class="btn-delete">🗑️ Deletar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tab: Send -->
        <div v-if="activeTab === 'send'" class="tab-content">
            <div class="send-section">
                <h3>📤 Enviar Avisos em Massa</h3>
                <p class="info-text">
                    Os emails serão enviados gradualmente (10 emails a cada 5 minutos) para evitar bloqueio por spam.
                </p>

                <div class="form-row">
                    <Select 
                        label="Template de Email*" 
                        :options="[{ name: 'Selecione um template', value: '' }, ...templates.filter(t => t.is_active).map(t => ({ name: t.name, value: t.id }))]" 
                        :value="sendForm.template_id" 
                        v-model="sendForm.template_id"
                    />
                    <div class="form-space"></div>
                    <Select 
                        label="Destinatários*" 
                        :options="recipientTypes" 
                        :value="sendForm.recipient_type" 
                        v-model="sendForm.recipient_type"
                    />
                </div>

                <div v-if="sendForm.template_id" class="template-preview">
                    <h4>Prévia do Template</h4>
                    <div class="preview-box">
                        <p><strong>Assunto:</strong> {{ templates.find(t => t.id == sendForm.template_id)?.subject }}</p>
                        <hr>
                        <div v-html="templates.find(t => t.id == sendForm.template_id)?.body"></div>
                    </div>
                </div>

                <div class="form-actions">
                    <Button type="primary" placeholder="Adicionar à Fila de Envio" @buttonPressed="queueEmails" />
                </div>
            </div>
        </div>

        <!-- Tab: Queue -->
        <div v-if="activeTab === 'queue'" class="tab-content">
            <div class="queue-section">
                <div class="queue-header">
                    <h3>📊 Status da Fila de Envio</h3>
                    <div class="queue-actions">
                        <Button type="primary" placeholder="🔄 Atualizar" @buttonPressed="loadQueueStatus" />
                        <Button type="secondary" placeholder="▶️ Processar Fila" @buttonPressed="processQueue" />
                        <Button type="danger" placeholder="🗑️ Limpar Enviados" @buttonPressed="clearQueue('sent')" />
                    </div>
                </div>

                <div v-if="queueStatus" class="queue-stats">
                    <div class="stat-card pending">
                        <div class="stat-number">{{ queueStatus.pending }}</div>
                        <div class="stat-label">Pendentes</div>
                    </div>
                    <div class="stat-card processing">
                        <div class="stat-number">{{ queueStatus.processing }}</div>
                        <div class="stat-label">Processando</div>
                    </div>
                    <div class="stat-card sent">
                        <div class="stat-number">{{ queueStatus.sent }}</div>
                        <div class="stat-label">Enviados</div>
                    </div>
                    <div class="stat-card failed">
                        <div class="stat-number">{{ queueStatus.failed }}</div>
                        <div class="stat-label">Falhados</div>
                    </div>
                </div>

                <div class="queue-list">
                    <h4>Últimos 50 Emails da Fila</h4>
                    
                    <div v-if="recentQueue.length === 0" class="empty-state">
                        <p>Nenhum email na fila.</p>
                    </div>

                    <table v-else class="queue-table">
                        <thead>
                            <tr>
                                <th>Destinatário</th>
                                <th>Email</th>
                                <th>Template</th>
                                <th>Agendado Para</th>
                                <th>Status</th>
                                <th>Enviado Em</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in recentQueue" :key="item.id">
                                <td>{{ item.recipient_name }}</td>
                                <td>{{ item.recipient_email }}</td>
                                <td>{{ item.template?.name || '-' }}</td>
                                <td>{{ formatDateTime(item.scheduled_at) }}</td>
                                <td>
                                    <span :class="['badge', getStatusBadgeClass(item.status)]">
                                        {{ getStatusLabel(item.status) }}
                                    </span>
                                </td>
                                <td>{{ formatDateTime(item.sent_at) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="queue-info">
                    <p><strong>ℹ️ Informação:</strong> A fila é processada automaticamente a cada minuto. Emails são enviados em lotes de 10 a cada 5 minutos para evitar bloqueio por spam.</p>
                    <p><strong>⚙️ Comando manual:</strong> <code>php artisan email:process-queue</code></p>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.notifications-container {
    padding: 20px;
    padding-bottom: 100px;
    max-width: 1400px;
    margin: 0 auto;
}

.header-section {
    background: white;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header-section h2 {
    color: #333;
    margin-bottom: 10px;
}

.subtitle {
    color: #666;
    font-size: 14px;
    margin: 0;
}

.tabs-nav {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}

.tab-button {
    flex: 1;
    padding: 12px 20px;
    background: white;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
}

.tab-button:hover {
    border-color: #2196f3;
    color: #2196f3;
}

.tab-button.active {
    background: #2196f3;
    color: white;
    border-color: #2196f3;
}

.badge-pending {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #ff5722;
    color: white;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: bold;
}

.tab-content {
    background: white;
    padding: 25px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.form-section h3,
.send-section h3,
.queue-section h3 {
    margin: 0 0 20px 0;
    color: #333;
}

.form-row {
    display: flex;
    gap: 15px;
    margin-bottom: 15px;
}

.form-space {
    width: 15px;
}

.form-group {
    flex: 1;
}

.form-group.full-width {
    width: 100%;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    color: #555;
    font-weight: 500;
    font-size: 14px;
}

.form-textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-family: monospace;
    font-size: 13px;
    resize: vertical;
}

.variables-help {
    margin: 20px 0;
    padding: 15px;
    background: #f0f7ff;
    border-left: 4px solid #2196f3;
    border-radius: 6px;
}

.variables-help p {
    margin: 0 0 10px 0;
    color: #333;
    font-size: 14px;
}

.variables-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.var-btn {
    padding: 6px 12px;
    background: #2196f3;
    color: white;
    border: none;
    border-radius: 4px;
    font-family: monospace;
    font-size: 12px;
    cursor: pointer;
    transition: background 0.3s;
}

.var-btn:hover {
    background: #1976d2;
}

.checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 14px;
    color: #555;
}

.checkbox-label input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.form-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
}

.templates-list {
    margin-top: 40px;
}

.templates-list h3 {
    margin-bottom: 20px;
    color: #333;
}

.template-card {
    background: #f9f9f9;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 15px;
}

.template-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.template-header h4 {
    margin: 0;
    color: #333;
}

.template-badges {
    display: flex;
    gap: 8px;
}

.badge {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
}

.badge-type {
    background: #e3f2fd;
    color: #1976d2;
}

.badge-success {
    background: #4caf50;
    color: white;
}

.badge-danger {
    background: #f44336;
    color: white;
}

.badge-warning {
    background: #ff9800;
    color: white;
}

.badge-info {
    background: #2196f3;
    color: white;
}

.template-body p {
    margin: 5px 0;
    color: #666;
    font-size: 13px;
}

.template-actions {
    display: flex;
    gap: 10px;
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #e0e0e0;
}

.btn-edit,
.btn-delete {
    padding: 8px 15px;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.3s;
}

.btn-edit {
    background: #2196f3;
    color: white;
}

.btn-edit:hover {
    background: #1976d2;
}

.btn-delete {
    background: #f44336;
    color: white;
}

.btn-delete:hover {
    background: #d32f2f;
}

.info-text {
    background: #fff3cd;
    border-left: 4px solid #ffc107;
    padding: 12px;
    margin-bottom: 20px;
    border-radius: 6px;
    color: #856404;
    font-size: 14px;
}

.template-preview {
    margin: 20px 0;
}

.template-preview h4 {
    margin-bottom: 10px;
    color: #333;
}

.preview-box {
    background: #f9f9f9;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 15px;
    font-size: 13px;
}

.preview-box hr {
    border: none;
    border-top: 1px solid #e0e0e0;
    margin: 10px 0;
}

.queue-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.queue-actions {
    display: flex;
    gap: 10px;
}

.queue-stats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
    margin-bottom: 30px;
}

.stat-card {
    background: #f9f9f9;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    border-left: 4px solid #ccc;
}

.stat-card.pending {
    border-left-color: #ff9800;
}

.stat-card.processing {
    border-left-color: #2196f3;
}

.stat-card.sent {
    border-left-color: #4caf50;
}

.stat-card.failed {
    border-left-color: #f44336;
}

.stat-number {
    font-size: 32px;
    font-weight: bold;
    color: #333;
    margin-bottom: 5px;
}

.stat-label {
    font-size: 14px;
    color: #666;
}

.queue-list h4 {
    margin-bottom: 15px;
    color: #333;
}

.queue-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.queue-table th,
.queue-table td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
}

.queue-table th {
    background: #f5f5f5;
    color: #555;
    font-weight: 600;
}

.queue-table tbody tr:hover {
    background: #f9f9f9;
}

.queue-info {
    margin-top: 30px;
    padding: 15px;
    background: #e8f5e9;
    border-left: 4px solid #4caf50;
    border-radius: 6px;
}

.queue-info p {
    margin: 8px 0;
    color: #2e7d32;
    font-size: 13px;
}

.queue-info code {
    background: #fff;
    padding: 2px 6px;
    border-radius: 3px;
    font-family: monospace;
    color: #d32f2f;
}

.empty-state {
    text-align: center;
    padding: 40px;
    color: #999;
}

.empty-state p {
    margin: 0;
    font-size: 14px;
}
</style>
